"use strict";

function CompoundError(errors) {
  this.errors = errors;
  this.name = "Compound error";
}

CompoundError.prototype = Error.prototype;

module.exports = CompoundError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/errors/compound.js
 ** module id = 478
 ** module chunks = 0
 **/